// @ts-ignore
import useApi from "./ServiceClient.tsx";
// @ts-ignore
import { config } from "./config.tsx";

export const useCategoryManagement = () => {
    const { GET, POST, DELETE } = useApi();
    
    const getCategories = () => {
        const response = GET(config?.category_management?.END_POINTS?.GET_ALL);
        return response;
    };

    const addCategory = (payload: any) => {
        const response = POST(
            config?.category_management?.END_POINTS?.ADD,
            payload
        );
        return response;
    };

    const updateCategory = (payload: any) => {
        const response = POST(
            config?.category_management?.END_POINTS?.UPDATE,
            payload
        );
        return response;
    };

    const deleteCategory = (id: string) => {
        const response = DELETE(`${config?.category_management?.END_POINTS?.DELETE}${id}`);
        return response;
    };

    const getCategoryById = (id: string) => {
        const response = GET(`${config?.category_management?.END_POINTS?.GET_BY_ID}${id}`);
        return response;
    };

    return {
        getCategories,
        addCategory,
        updateCategory,
        deleteCategory,
        getCategoryById
    };
};
